import createSvgIcon from '../Utils/CreateSvgIcon';

export const Gallery = createSvgIcon(
  <path
    d="M5 19L19 19L19 5L5 5L5 19ZM19 21L21 21V19L21 5L21 3L19 3L5 3H3L3 5L3 19L3 21L5 21L19 21ZM17 17H13L13 13L17 13L17 17ZM13 11L17 11V7L13 7L13 11ZM11 17L7 17L7 13L11 13L11 17ZM7 11L11 11L11 7L7 7L7 11Z"
    fillRule="evenodd"
  />,
  'Gallery',
);
